let oauth2MiddlewareRegistered = false;
export const registerOauth2Middleware = ()=>{
    oauth2MiddlewareRegistered = true;
};
export const getOauth2MiddlewareRegistered = ()=>oauth2MiddlewareRegistered;
